export const SET_LANG = 'SET_LANG'
export const SET_IS_CHECK_USER_LOGIN = "SET_IS_CHECK_USER_LOGIN"
export const SET_IS_LOGGED_IN = "SET_IS_LOGGED_IN"
export const SET_LOGIN_TYPE = "SET_LOGIN_TYPE"
export const SET_USER_PERMISSIONS = "SET_USER_PERMISSIONS"
export const SET_TEAMS_DATA = "SET_TEAMS_DATA"
export const SET_USER_INFO = "SET_USER_INFO"
export const SET_REDIRECT_URL = "SET_REDIRECT_URL"